export const useCreateQueryKey = ({key, data, namePrefix, useLocaleKey}) => {
    //const {locale} = useRouter()
    const locale = 'en'

    const name = namePrefix
        ? (useLocaleKey ? `${key}_${namePrefix}_${locale}` : `${key}_${namePrefix}`)
        : (useLocaleKey ? `${key}_${locale}` : `${key}`)

    if (data){
        return [name, data]
    }

    return name
}